import { useContext } from 'react';
import { DeviceHeaderContext } from './DeviceHeaderContext';

/**
 * This hook retrieves the device type from the DeviceHeaderContext.
 * After pages router support is dropped, this hook will retrieve the provided headers promise from the root layout and resolve it to get the device type
 * @returns
 */
export const useDeviceHeader = () => {
  const detectedDevice = useContext(DeviceHeaderContext);
  // re-enable after pages router support is dropped
  // const detectedDevicePromise = use(DeviceHeaderContext);

  if (!detectedDevice) {
    return 'mobile';
    // re-enable after pages router support is dropped
    // throw new Error('useDeviceHeader must be used within a DeviceHeaderProvider');
  }

  // re-enable after pages router support is dropped
  // return use(detectedDevicePromise);
  return detectedDevice;
};
